export default "__VITE_ASSET__Dszn8nGc__"